import { useState } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import useApi from "../../api";
import { NXForm } from "../common";
import AsyncSelectStyled from "../asyncSelectStyled";


function AddProductPromo({ isOpen, onClose, code, onRefresh }: {isOpen: boolean; onClose: () => void; code: string | null, onRefresh: () => void}) {
    const [selectedProducts, setSelectedProducts] = useState<any>([]);
    const api = useApi();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const payload = {
            promo_code: code,
            product_ids: selectedProducts
        }
        api.attachPromocodeEntity(payload).then((response) => {
            toast.success("Promocode attached to products successfully");
            onClose();
            onRefresh();
        }, (error) => {
            toast.error("Failed to attach promocode to products");
        })
    };


    const fetchOptions = async (inputValue: any) => {
        const params = {
        search: inputValue
        };
        const response = await api.getProductsMinimal(params) as any;  
        return response.map((item: any) => {
        const label = `${item.name} - #ID ${item.id}`;
            
        return { label, value: item.id, ...item };
        });
    };

    const handleCustomerChange = (selectedOption: any) => {
        const ids = selectedOption.map((item: any) => item.value);
        setSelectedProducts(ids);
    };

    return (
        <NxtbnDrawer title={`Allow promocode for specific products only`} isOpen={isOpen} onClose={onClose}>
        <NXForm
            className="p-4"
            onSubmit={handleSubmit}
            title=""
            nonFieldError={{}}
        >
            <div className="mb-4">
            <label htmlFor="product-select" className="block mb-2 font-medium">Select Product</label>
            <AsyncSelectStyled
                loadOptions={fetchOptions}
                onChange={handleCustomerChange}
                isClearable={true}
                isMulti={true}
                valueMax={500}
                // placeholder="Select a customer"
                addComponentName="customer"
                />
            </div>
            <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
            Save
            </button>
        </NXForm>
        </NxtbnDrawer>
    );
}

export default AddProductPromo;
